export default __webpack_public_path__ + "static/media/111.3b3e62e0.jpg";